import usePopupStore from "./store";

export default usePopupStore;
